<template>
    <div>
    <div class="header wrapper">
        <div class='success'>
            <img src="../payPage/imgs/gou.png" alt="" style="width:18px;height:18px;margin-right:10px;">
            <p style="color:rgba(8,193,96,1);font-size:16px;margin-right:10px;">订单提交成功，请尽快支付！</p>
            <p style="margin-right:10px;">订单号 : 11111</p>
            <p>应付金额:<span style='color:red;'> 6666 </span>元 </p>
        </div>
    </div>
    <div class="paybox wrapper">
        <div class="title">
            <img src="../payPage/imgs/weixin.png" alt="" style="width:36px;height:30px;margin-right:10px">
            <span style="font-weight: 800;">微信支付</span>
        </div>
        <div class="pay">
            <span class="time">距离二维码过期还剩 <span style="color:rgba(255, 126, 0, 1)">33</span> 秒，过期后请刷新页面重新获取二维码。</span>
            <div class="imgbox">
                <div class="scorbox">
                    <img src="../payPage/imgs/demo.png" alt="" class="scor">
                    <div class="hintinfo">
                        <img src="../payPage/imgs/scor.png" alt="" style="width:30px;height:30px;margin:0 20px">
                        <div style="color: #fff">
                            请使用微信扫描<br/>
                            二维码以完成支付
                        </div>
                    </div>
                </div>
                <img src="../payPage/imgs/phone.png" alt="" style="width:310px;height:410px">
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "index.vue"
    }
</script>

<style scoped>
    p {
        margin: 0;
        padding: 0;
    }

    .wrapper {
        width: 1200px;
        margin: 0 auto;

    }

    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 600px;
        height: 50px;
        background: rgba(242, 253, 237, 1);
        margin: 0 auto;
        margin-top: 40px;
        margin-bottom: 20px;
        box-sizing: border-box;
    }

    .content {
        width: 600px;
        height: 270px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .biggou {
        display: block;
        box-sizing: border-box;
        width: 90px;
        height: 90px;
        margin-right: 20px;
    }

    .infobox {
        text-align: center;
        height: 90px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .cong {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        text-align: center;
    }

    button {
        width: 150px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        background: rgba(8, 193, 96, 1);
        color: #fff;
        border: none;
        font-size: 16px;
    }
</style>